import { INDUSTRIES } from "../navigation";

// Industry images
import AgricultureImgUrl from "@/assets/images/industries/agriculture.png";
import AgricultureThumbUrl from "@/assets/images/industries/agriculture_thumb.png";
import CarRentalImgUrl from "@/assets/images/industries/car-rental.png";
import CarRentalThumbUrl from "@/assets/images/industries/car-rental_thumb.png";
import CarShareImgUrl from "@/assets/images/industries/car-share.png";
import CarShareThumbUrl from "@/assets/images/industries/car-share_thumb.png";
import ConstructionImgUrl from "@/assets/images/industries/construction.png";
import ConstructionThumbUrl from "@/assets/images/industries/construction_thumb.png";
import DeliveryImgUrl from "@/assets/images/industries/delivery.png";
import DeliveryThumbUrl from "@/assets/images/industries/delivery_thumb.png";
import EmergencyImgUrl from "@/assets/images/industries/emergency-services.png";
import EmergencyThumbUrl from "@/assets/images/industries/emergency-services_thumb.png";
import GovernmentImgUrl from "@/assets/images/industries/government-municipalities.png";
import GovernmentThumbUrl from "@/assets/images/industries/government-municipalities_thumb.png";
import PublicTransportImgUrl from "@/assets/images/industries/public-transport.png";
import PublicTransportThumbUrl from "@/assets/images/industries/public-transport_thumb.png";
import ShippingImgUrl from "@/assets/images/industries/shipping.png";
import ShippingThumbUrl from "@/assets/images/industries/shipping_thumb.png";
import TourismImgUrl from "@/assets/images/industries/tourism.png";
import TourismThumbUrl from "@/assets/images/industries/tourism_thumb.png";
import TruckingImgUrl from "@/assets/images/industries/trucking-transport.png";
import TruckingThumbUrl from "@/assets/images/industries/trucking-transport_thumb.png";

// Industry icons
import map_icon from "@/assets/icons/why-trackmate/take-control/map-pin.svg";
import bell_icon from "@/assets/icons/why-trackmate/take-control/bell-alert.svg";
import shield_icon from "@/assets/icons/become-dealer/shield-check.svg";
import screwdriver_icon from "@/assets/icons/why-trackmate/save-costs/wrench-screwdriver.svg";

export const industriesData: IIndustryCard[] = [
  {
    path: INDUSTRIES.carShare,
    title: "Car share",
    subTitle:
      "Trackmate’s GPS tracking enables real-time visibility for your stakeholders and superior tracking capabilities for your customers. Tracking vehicle health enables proactive maintenance, extending the life of your fleet while ensuring your customers enjoy the ride.",
    imageUrl: CarShareImgUrl,
    thumbnail: CarShareThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Precise vehicle location tracking" },
      { iconUrl: bell_icon, description: "Automated dispatch and vehicle allocation" },
      { iconUrl: shield_icon, description: "Detailed reporting improves fleet management" },
      { iconUrl: screwdriver_icon, description: "Geofencing ensures vehicles stay within service areas" },
    ],
  },
  {
    path: INDUSTRIES.carRental,
    title: "Car rental",
    subTitle:
      "Trackmate helps dealerships and car rental agencies gain fleet visibility, preventing loss and enabling billing accuracy. Vehicle health monitoring keeps you apprised of fleet condition, enabling proactive maintenance while improving driver safety.",
    imageUrl: CarRentalImgUrl,
    thumbnail: CarRentalThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Unlimited GPS-based vehicle tracking" },
      { iconUrl: bell_icon, description: "Maintenance management" },
      { iconUrl: shield_icon, description: "Real-time incident monitoring" },
      { iconUrl: screwdriver_icon, description: "Enables fast recovery and superior loss prevention" },
    ],
  },
  {
    path: INDUSTRIES.truckingTransport,
    title: "Trucking & transport",
    subTitle:
      "Gain visibility into your entire fleet and drive cost efficiency with real-time tracking features, route optimization, and detailed vehicle health reports to enable proactive maintenance.",
    imageUrl: TruckingImgUrl,
    thumbnail: TruckingThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Real-Time Tracking & Vehicle Location" },
      { iconUrl: bell_icon, description: "Route Optimization" },
      { iconUrl: shield_icon, description: "Vehicle Health Monitoring" },
      { iconUrl: screwdriver_icon, description: "Complies with All Transportation Legal Frameworks" },
    ],
  },
  {
    path: INDUSTRIES.tourismRecreation,
    title: "Tourism & recreation",
    subTitle:
      "Trackmate keeps your fleet on schedule while improving passenger safety and satisfaction. Real-time location tracking ensures itinerary compliance and minimizes overtime. At the same time, vehicle monitoring and alerts help you keep tabs on driver habits, mitigating risk and reducing costs from end to end.",
    imageUrl: TourismImgUrl,
    thumbnail: TourismThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Real-time vehicle tracking" },
      { iconUrl: bell_icon, description: "Monitor itineraries" },
      { iconUrl: shield_icon, description: "Emergency services integration" },
      { iconUrl: screwdriver_icon, description: "Improve driver safety" },
    ],
  },
  {
    path: INDUSTRIES.truckingDelivery,
    title: "Trucking & delivery services",
    subTitle:
      "Visibility and transparency support reliability, on-time deliveries, and customer satisfaction. Trackmate enables route optimization, monitors vehicle health, and provides pinpoint-accurate tracking to ensure your cargo gets to its destination on time.",
    imageUrl: DeliveryImgUrl,
    thumbnail: DeliveryThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Route optimization and rerouting" },
      { iconUrl: bell_icon, description: "Real-time tracking and notifications" },
      { iconUrl: shield_icon, description: "Vehicle maintenance alerts" },
      { iconUrl: screwdriver_icon, description: "Integrated proof of delivery" },
    ],
  },
  {
    path: INDUSTRIES.shippingMaritime,
    title: "Shipping and maritime",
    subTitle:
      "Trackmate ensures the safety and security of your maritime cargo in transit. Track your cargo in real-time with pinpoint accuracy, confidently manage rerouting, and monitor container conditions with configurable alerts.",
    imageUrl: ShippingImgUrl,
    thumbnail: ShippingThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Track the vessel, container, and individual crates" },
      { iconUrl: bell_icon, description: "Simplify multi-mode international shipping" },
      { iconUrl: shield_icon, description: "Real-time weather monitoring" },
      { iconUrl: screwdriver_icon, description: "Emergency alert system " },
    ],
  },
  {
    path: INDUSTRIES.publicTransport,
    title: "Public transportation",
    subTitle:
      "Public transportation services require reliability and punctuality. Trackmate's solutions enhance public transit management with real-time tracking, route optimization, and passenger information systems for a seamless commuter experience.",
    imageUrl: PublicTransportImgUrl,
    thumbnail: PublicTransportThumbUrl,
    characteristics: [
      {
        iconUrl: map_icon,
        description: "Real-time Bus/Train Location Tracking",
      },
      { iconUrl: bell_icon, description: "Route Optimization for Timeliness" },
      { iconUrl: shield_icon, description: "Passenger Information Displays" },
      { iconUrl: screwdriver_icon, description: "Traffic and Incident Alerts" },
    ],
  },
  {
    path: INDUSTRIES.emergencyService,
    title: "Emergency services",
    subTitle:
      "Swift response is critical for emergency services. Trackmate's solutions provide real-time tracking, route optimization, and incident reporting features to ensure rapid and effective emergency response.",
    imageUrl: EmergencyImgUrl,
    thumbnail: EmergencyThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Real-time Vehicle Location" },
      {
        iconUrl: bell_icon,
        description: "Dynamic Route Adjustment for Emergencies",
      },
      {
        iconUrl: shield_icon,
        description: "Incident Reporting and Documentation",
      },
      {
        iconUrl: screwdriver_icon,
        description: "Emergency Beacon Integration",
      },
    ],
  },
  {
    path: INDUSTRIES.governmentMunicipalities,
    title: "Government & municipalities",
    subTitle:
      "Government and municipal services require efficient fleet management for various operations. Trackmate's solutions offer real-time tracking, maintenance insights, and compliance features for optimized resource allocation.",
    imageUrl: GovernmentImgUrl,
    thumbnail: GovernmentThumbUrl,
    characteristics: [
      {
        iconUrl: map_icon,
        description: "Fleet Location and Utilization Tracking",
      },
      { iconUrl: bell_icon, description: "Preventive Maintenance Scheduling" },
      {
        iconUrl: shield_icon,
        description: "Compliance Reporting (Emissions, etc.)",
      },
      {
        iconUrl: screwdriver_icon,
        description: "Asset Management for Government Vehicles",
      },
    ],
  },
  {
    path: INDUSTRIES.agriculture,
    title: "Agriculture",
    subTitle:
      "Precision is essential in modern agriculture. Trackmate's solutions provide farmers with real-time monitoring of equipment, crop health insights, and optimized routes for efficient farm management.",
    imageUrl: AgricultureImgUrl,
    thumbnail: AgricultureThumbUrl,
    characteristics: [
      {
        iconUrl: map_icon,
        description: "Equipment Tracking and Usage Monitoring",
      },
      { iconUrl: bell_icon, description: "Crop Health Monitoring" },
      {
        iconUrl: shield_icon,
        description: "Automated Irrigation System Integration",
      },
      {
        iconUrl: screwdriver_icon,
        description: "Farming Equipment Maintenance Alerts",
      },
    ],
  },
  {
    path: INDUSTRIES.constructionPlumbing,
    title: "Construction, plumbing, HVAC",
    subTitle:
      "Construction and service industries benefit from equipment and vehicle tracking. Trackmate's solutions offer real-time location tracking, maintenance scheduling, and route optimization to enhance efficiency and project management.",
    imageUrl: ConstructionImgUrl,
    thumbnail: ConstructionThumbUrl,
    characteristics: [
      { iconUrl: map_icon, description: "Equipment and Vehicle Tracking" },
      {
        iconUrl: bell_icon,
        description: "Maintenance Scheduling for Tools and Vehicles",
      },
      { iconUrl: shield_icon, description: "Job Site Route Optimization" },
      { iconUrl: screwdriver_icon, description: "Fuel Consumption Monitoring" },
    ],
  },
];
